import { brandQuestionsFor, VERTICALS, type BrandQuestion } from '@/shared/constants/verticals';

export type { BrandQuestion };
export { brandQuestionsFor };

/**
 * Dental-worded question set.
 *
 * Safe wherever only `questionKey` or ordering is needed — every vertical uses
 * the same keys in the same order, because `brandArchetype.ts` scores by
 * position. Anything that *renders* the text must call `brandQuestionsFor(vertical)`
 * instead, or a medical practice is asked about "doing dentistry differently".
 */
export const BRAND_Q = VERTICALS.dental.brandQuestions;

export type Pick = 0 | 1 | null;
